import { createElementBlock as r, openBlock as t, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(a, e) {
  return t(), r("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m.26-14.395a6.4 6.4 0 0 1 5.41 9.367l-4.482-3.658zm-.52 0-.928 5.709-4.481 3.658a6.4 6.4 0 0 1 5.409-9.367m-5.148 9.819L12 13.372l5.408 2.052A6.4 6.4 0 0 1 12 18.4a6.4 6.4 0 0 1-5.408-2.976"
    }, null, -1)
  ]));
}
const m = { render: l };
export {
  m as default,
  l as render
};
//# sourceMappingURL=ic_brand_mercedes-Ci8sPmMH.js.map
